import { useLocale } from "next-intl";
import { useQuery } from "@tanstack/react-query";

import { getMarketMatches } from "@/api/matches/getMarketMatches";

import { FeedType } from "@/types/SportsApiResponses";
interface Options {
  id: number;
  feedType: FeedType;
  providerId: number;
}

export const useMarketMatches = (options: Options, queryKey: string = "") => {
  const locale = useLocale();

  return useQuery({
    queryKey: [queryKey],
    enabled: Boolean(queryKey),

    queryFn: async ({ signal }) => {
      const params = { lang: locale, ...options };
      return await getMarketMatches({ params, signal });
    },
  });
};
